module.exports = __webpack_public_path__ + "static/media/KADHO_LOGO.780bd983.png";